/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchWidgetContainer_user$ref: FragmentReference;
export type SearchWidgetContainer_user = {|
  +id: string,
  +$refType: SearchWidgetContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SearchWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8e92c17960a693d18485f0714d95af79';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Widget/Widgets/Search/__generated__/SearchWidgetContainer_user.graphql.js